import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const trackBrokerClick = (source, linkType = 'cpa') => {
    try { localStorage.setItem('ptg_broker_click', new Date().toISOString()); } catch { /* ignore */ }
    axios.post(`${API}/track/broker-click`, { source, link_type: linkType }, { withCredentials: true }).catch(() => {});
};

export const getPreSignupBrokerClick = () => {
    try { return localStorage.getItem('ptg_broker_click'); } catch { return null; }
};
